<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><b><i>TO WALTER L. BRADBURY</i></b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5f069c54